export default __webpack_public_path__ + "static/media/notification.9d96ed51.svg";